import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
    Redirect,
    Route,
    Switch,
} from 'react-router-dom';

import {
    Grid,
    Row,
} from 'yurstrap';

import { getLocationSelector } from '../../commons/selectors/RouterSelector';

import HomePage from './HomePage';
import ContactSupportFAQ from './ContactSupport/ContactSupportFAQ';
import ContactSupportEmail from './ContactSupport/ContactSupportEmail';
import Sidebar from './ContactSupport/Sidebar';
import ContactSupportEmailSuccess from './ContactSupport/ContactSupportEmailSuccess';
import ContactSalesman from './ContactSalesman/ContactSalesman';
import ContactSalesmanSuccess from './ContactSalesman/ContactSalesmanSucces';

import NotificationsList from '../../components/Notifications/NotificationsList';

import Routes from '../constants/Routes';

export class SupportContent extends Component {

    constructor(props) {
        super(props);
        this.renderSupport = this.renderSupport.bind(this);
    }

    renderSupport() {
        const {
            location,
        } = this.props;
        return (
            <div className="contact-form-front--bg">
                <Grid size="small" className="p-0 contact-form-front">
                    <Row noCol>
                        <Sidebar />
                        <Switch location={location}>
                            <Route
                                path={Routes.FAQ_PAGE.link}
                                component={ContactSupportFAQ}
                            />
                            <Route
                                path={Routes.CONTACT_SUPPORT_SUCCESS.link}
                                component={ContactSupportEmailSuccess}
                            />
                            <Route
                                path={Routes.CONTACT_BY_EMAIL.link}
                                component={ContactSupportEmail}
                            />
                        </Switch>
                    </Row>
                </Grid>
            </div>
        );
    }

    render() {
        const { location } = this.props;
        return (
            <>
                <Switch location={location}>
                    <Route
                        path={Routes.HOME_PAGE.link}
                        component={HomePage}
                    />
                    <Route
                        path={Routes.CONTACT_SALESMAN_SUCCESS.link}
                        component={ContactSalesmanSuccess}
                    />
                    <Route
                        path={Routes.CONTACT_SALESMAN.link}
                        component={ContactSalesman}
                    />
                    <Route
                        path={Routes.SUPPORT_ROOT.link}
                        component={this.renderSupport}
                    />
                    <Redirect to={Routes.HOME_PAGE.link} />
                </Switch>
                <NotificationsList />
            </>
        );
    }

}

SupportContent.propTypes = {
    location: PropTypes.object.isRequired,
    isModal: PropTypes.bool,
};

SupportContent.defaultProps = {
    isModal: false,
};

function mapStateToProps(state, ownProps) {
    return {
        location: ownProps.location || getLocationSelector(state),
    };
}

export default connect(
    mapStateToProps,
)(SupportContent);
